import { render, staticRenderFns } from "./JvmInfo.vue?vue&type=template&id=f32ab730"
import script from "./JvmInfo.vue?vue&type=script&lang=js"
export * from "./JvmInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f32ab730')) {
      api.createRecord('f32ab730', component.options)
    } else {
      api.reload('f32ab730', component.options)
    }
    module.hot.accept("./JvmInfo.vue?vue&type=template&id=f32ab730", function () {
      api.rerender('f32ab730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/monitor/JvmInfo.vue"
export default component.exports